const icon = require('vue-svgicon');
icon.register({
    'close': {
        width: 32,
        height: 32,
        viewBox: '0 0 32 32',
        data: `<path pid="0" d="M19.009 16L31.377 3.632c.83-.83.83-2.177-.001-3.007a2.128 2.128 0 00-3.009-.003L15.998 12.99 3.632.623a2.128 2.128 0 00-3.01 3.009L12.99 15.999.624 28.366a2.127 2.127 0 00.002 3.01c.83.83 2.177.831 3.008 0L16 19.009l12.368 12.368c.83.83 2.177.83 3.007-.001a2.128 2.128 0 00.003-3.009L19.009 16z"/>`,
    },
});
